import React from "react"
import Carousel from "../../carousel/Carousel"
import { Link } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import Edges from "../../Edges"

interface ISocialBlockProps {
  description: string
  heading: string
  socialIcons: {
    url: string
    icon: {
      altText: string
      gatsbyImage: any
    }
  }[]
  slider: {
    user: {
      target: string
      title: string
      url: string
    }
    image: {
      altText: string
      gatsbyImage: any
    }
  }[]
}

const SocialBlock: React.FC<ISocialBlockProps> = ({
  heading,
  description,
  socialIcons,
  slider,
}) => {
  return (
    <div
      className={
        slider ? "bg-darkBlue pb-16 text-white" : "bg-darkBlue  text-white"
      }
    >
      <Edges size="md">
        <div className="px-[15px] sm:px-8 lg:px-0">
          {heading && (
            <h2 className="mb-3 pt-16 text-h2 uppercase">{heading}</h2>
          )}
          {description && (
            <p className="mb-5 max-w-[605px] text-body1">{description}</p>
          )}
          {socialIcons && (
            <div
              className={
                slider ? " flex space-x-4 pb-6" : " flex space-x-4 pb-16"
              }
            >
              {socialIcons?.map(({ url, icon }, i) => {
                const icons = icon?.gatsbyImage && getImage(icon.gatsbyImage)
                return (
                  <a href={url} target="_blank" rel="noreferrer" key={i}>
                    {icons && (
                      <GatsbyImage image={icons} alt={icon.altText || ""} />
                    )}
                  </a>
                )
              })}
            </div>
          )}
        </div>

        {slider && (
          <Carousel checkLength={slider?.length} minImages={4}>
            {slider?.map(({ user, image }, index) => {
              const socialImages =
                image?.gatsbyImage && getImage(image?.gatsbyImage)

              return (
                <div key={index}>
                  <div className="relative mx-auto w-[200px]">
                    {socialImages && (
                      <GatsbyImage
                        image={socialImages}
                        alt={image.altText || ""}
                        className="mx-[5px] h-[200px] rounded"
                      />
                    )}

                    {user?.title && (
                      <Link
                        to={user?.url ? user?.url : ""}
                        className="relative top-[5px] ml-[6px] text-body2"
                      >
                        {user?.title}
                      </Link>
                    )}
                  </div>
                </div>
              )
            })}
          </Carousel>
        )}
      </Edges>
    </div>
  )
}

export default SocialBlock
